class Stepper {
    constructor(
        steps,
        stepsWrapper,
        nextStepButton,
        prevStepButton,
        submitButton,
        progressBar,
        validator
    ) {
        if (!steps || !stepsWrapper) {
            console.error("No steps nor stepsWrapper specified");
            return false;
        }

        let currentStep;

        this.getSteps = () => steps;
        this.getStep = (i) => steps[i];
        this.getTotalSteps = () => steps.length;
        this.getCurrentStep = () => currentStep;
        this.goToStep = (stepNum = -1) => {
            if (stepNum < 0) {
                return false;
            }

            if (stepNum + 1 > this.getTotalSteps()) {
                return false;
            }

            currentStep = stepNum;
            stepsWrapper.style.height = steps[currentStep].offsetHeight;

            for (let i = 0; i < this.getTotalSteps(); i++) {
                const step = this.getStep(i);
                step.style.position = "absolute";
                step.style.transform = `translateX(${(i - stepNum) * 100}%)`;
                step.style.display = "block";
                progressBar
                    ? (progressBar.style.width = `${
                        (100 * (currentStep + 1)) / this.getTotalSteps()
                        }%`)
                    : null;
            }

            if (this.getCurrentStep() > 0) {
                prevStepButton.style.display = "flex";
            } else {
                prevStepButton.style.display = 'none';
            }

            if (!validator[this.getCurrentStep()].validate()) {
                nextStepButton.disabled = true;
                submitButton.disabled = true;
            } else {
                nextStepButton.disabled = false;
                submitButton.disabled = false;
            }

            if (submitButton && this.getTotalSteps() - 1 === this.getCurrentStep()) {
                nextStepButton.style.display = "none";
                submitButton.style.display = "flex";
            } else {
                nextStepButton.style.display = 'flex';
                submitButton.style.display = 'none';
            }

            return currentStep;
        };

        this.setHeight = () => {
            stepsWrapper.style.height = steps[currentStep].offsetHeight;
        };

        this.nextStep = () => {
            if (validator[this.getCurrentStep()].validate()) {
                this.goToStep(this.getCurrentStep() + 1);
            } else {
                validator[this.getCurrentStep()].showErrors();
                this.setHeight();
            }
        };

        this.prevStep = () => {
            this.goToStep(this.getCurrentStep() - 1);
        };

        stepsWrapper.style.position = "relative";
        stepsWrapper.style.overflow = "hidden";
        stepsWrapper.style.height = steps[0].offsetHeight;

        this.goToStep(0);

        nextStepButton.addEventListener("click", this.nextStep);
        prevStepButton.addEventListener("click", this.prevStep);

        const stepper = this;
        setInterval(function () {
            stepper.setHeight();
        }, 200);
    }
}

export default Stepper;
